var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1000 1000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.7 0 0 .7 149.58 379.67)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 345,
    "data-background-color": "#e65728",
    viewBox: "0 0 396 137",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.24 -.23545)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 395.52,
    height: 137.47,
    viewBox: "0 0 395.5199999999999 137.47089089309503",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 395.52,
    height: 137.47,
    viewBox: "0 0 684.3059648208468 237.84423196647649",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(288.79 24.981)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 395.52,
    height: 187.88,
    viewBox: "0 0 395.52 187.88273615635177",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 395.52,
    height: 187.88,
    viewBox: "0 0 395.52 187.88273615635177",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 395.52,
    height: 187.88,
    viewBox: "0 0 395.52 187.88273615635177",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    width: 395.52,
    height: 187.88,
    "data-palette-color": "#ffffff",
    viewBox: "1.55 -43.35 92.09 43.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "undefined-text-0",
    d: "m11.9 0.4q-4.7 0-7.52-2.95-2.83-2.95-2.83-8.1v-19.8q0-6.4 2.55-9.65t8-3.25q4.75 0 7.65 2.6t2.9 7.5v7.4h-8.55v-6.35q0-1.85-0.45-2.55t-1.55-0.7q-1.15 0-1.57 0.8-0.43 0.8-0.43 2.35v21.55q0 1.7 0.5 2.47 0.5 0.78 1.5 0.78 2 0 2-3.25v-7.75h8.65v8.1q0 10.8-10.85 10.8zm20.9-0.4h-8.35l4.15-42.95h14.55l4.1 42.95h-8.15l-0.6-6.95h-5.2l-0.5 6.95zm2.75-35.65-1.6 21.85h3.9l-1.9-21.85h-0.4zm14.3 35.65v-42.95h11.35q5.15 0 7.35 3.32 2.2 3.33 2.2 9.73t-1.95 9.65-7 3.25h-3.5v17h-8.45zm8.45-24.75h0.5q1.55 0 2.27-0.58 0.73-0.57 0.95-1.65 0.23-1.07 0.23-3.07 0-2.7-0.6-3.9t-2.4-1.2h-0.95v10.4zm25.34 25.15q-5.85 0-8.45-2.9t-2.6-9.35v-4.2h8.45v5.35q0 3.2 2.05 3.2 1.15 0 1.6-0.68 0.45-0.67 0.45-2.27 0-2.1-0.5-3.48-0.5-1.37-1.27-2.3-0.78-0.92-2.78-2.87l-3.7-3.7q-4.3-4.2-4.3-9.3 0-5.5 2.53-8.38 2.52-2.87 7.37-2.87 5.8 0 8.35 3.07 2.55 3.08 2.55 9.63h-8.75l-0.05-2.95q0-0.85-0.47-1.35-0.48-0.5-1.33-0.5-1 0-1.5 0.55t-0.5 1.5q0 2.1 2.4 4.35l5 4.8q1.75 1.7 2.9 3.22 1.15 1.53 1.85 3.6 0.7 2.08 0.7 4.93 0 6.35-2.32 9.62-2.33 3.28-7.68 3.28z",
    fill: "#fff",
    "data-fill-palette-color": "primary"
  })))))))), /*#__PURE__*/React.createElement("svg", _extends({
    width: 244.43,
    height: 237.84,
    viewBox: "0 0 244.43135999999998 237.84423196647649",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon-icon-0",
    width: 244.43,
    height: 237.84,
    enableBackground: "new 0 0 100 100",
    fill: "#fff",
    "data-fill-palette-color": "accent",
    viewBox: "9.015518145953859 10.781 81.96999163598771 79.761",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m10.877 62.405 0.68-1.16c4.742 17.301 20.397 29.297 38.443 29.297 18.398 0 34.319-12.464 38.717-30.311 0.133-0.536-0.195-1.078-0.731-1.21-0.534-0.128-1.078 0.196-1.21 0.732-4.178 16.951-19.3 28.789-36.776 28.789-17.183 0-32.083-11.45-36.548-27.948l1.345 0.789c0.477 0.28 1.089 0.119 1.368-0.357 0.279-0.477 0.12-1.089-0.356-1.369l-3.334-1.954c-0.479-0.28-1.091-0.12-1.368 0.357l-1.954 3.334c-0.279 0.477-0.12 1.089 0.356 1.369 0.159 0.093 0.333 0.137 0.505 0.137 0.343-1e-3 0.677-0.177 0.863-0.495z",
    "data-fill-palette-color": "accent"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m90.419 38.243c-0.496-0.238-1.094-0.03-1.335 0.467l-0.646 1.343c-4.751-17.289-20.395-29.272-38.438-29.272-18.418 0-34.342 12.48-38.726 30.35-0.131 0.537 0.197 1.078 0.733 1.209 0.08 0.02 0.16 0.029 0.239 0.029 0.449 0 0.858-0.306 0.971-0.762 4.164-16.972 19.289-28.826 36.783-28.826 17.164 0 32.042 11.416 36.529 27.879l-1.269-0.61c-0.495-0.238-1.094-0.03-1.335 0.467-0.239 0.498-0.03 1.095 0.468 1.334l3.482 1.676c0.14 0.067 0.287 0.099 0.433 0.099 0.372 0 0.729-0.208 0.902-0.566l1.676-3.482c0.24-0.498 0.031-1.096-0.467-1.335z",
    "data-fill-palette-color": "accent"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m43.361 63.344c0.256 0 0.512-0.098 0.707-0.293l23.696-23.696c0.391-0.391 0.391-1.023 0-1.414s-1.023-0.391-1.414 0l-22.989 22.989-9.712-9.712c-0.391-0.391-1.023-0.391-1.414 0s-0.391 1.023 0 1.414l10.419 10.419c0.196 0.195 0.451 0.293 0.707 0.293z",
    "data-fill-palette-color": "accent"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.715ccb4093d11f8e2d6aa4a85e81bbb9.svg";
export { ForwardRef as ReactComponent };